///
/// EarthBrowser
///
/// Migration v11 to v12: Add SQL Terminal command history persistence
///
/// Created by Matt Giger on 12/19/2024
/// Copyright (c) 2024 Geodata Labs
///

interface StateV11 {
	userInterface?: Record<string, unknown>
}

/**
 * Migration from version 11 to 12: Add persistent SQL command history
 * - Adds sqlCommandHistory field to userInterface slice (empty array)
 * - SQL command history was previously in dialogSlice (non-persistent)
 * - Now moved to userInterface slice for persistence across launches
 * - Stores up to 100 most recent SQL commands
 */
export function migrateV11toV12(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV11

	// Return new state with sqlCommandHistory added
	return {
		...s,
		userInterface: {
			...s.userInterface,
			sqlCommandHistory: []
		}
	}
}
